/* Do not edit this file. */
/* Any state information should be in /store/app.js */

import { createStore } from "vuex";

import app from "@/store/app";
import auth from "@/store/auth";
import env from "@/store/env";
import datastore from "@/store/datastore";

const store = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    auth,
    env,
    datastore
  }
});

export default store;
